module.exports = {"title":"«ТАНКИ» в кино с 26 апреля","description":"Сходи в кино на фильм «ТАНКИ» и получи шанс выиграть машину!","image":"https://tanki.rambler.ru/img/share.jpg","url":"https://tanki.rambler.ru/","fbappid":396959934055666,"GTM":"GTM-MM3VRX8"}


//////////////////
// WEBPACK FOOTER
// ./js/meta.json
// module id = 346
// module chunks = 0